<template>
  <div id="app">
    <a-config-provider :locale="lang">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/locale/en_US";
import jaJP from "ant-design-vue/es/locale/ja_JP"
export default {
  name: "app",
  data() {
    return {
      zhCN,
      enUS,
      jaJP
    };
  },
  computed: {
    lang() {
      if (this.$store.state.i18n.lang === "zh_CN") {
        return this.zhCN;
      }
      if (this.$store.state.i18n.lang === "en_US") {
        return this.enUS;
      }
      return this.jaJP;
    },
  }
};
</script>
